import { render, staticRenderFns } from "./modalPhieuPhauThuat.vue?vue&type=template&id=98dc5a58&scoped=true"
import script from "./modalPhieuPhauThuat.vue?vue&type=script&lang=js"
export * from "./modalPhieuPhauThuat.vue?vue&type=script&lang=js"
import style0 from "./modalPhieuPhauThuat.vue?vue&type=style&index=0&id=98dc5a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc5a58",
  null
  
)

export default component.exports